import Button from '@shared/components/core/button/CoreButton';
import PageBannerCard from '@shared/components/core/card/PageBannerCard';
import ActivateLicenseMinorCTA from '@shared/components/license/ActivateLicenseMinorCTA';
import { getBaseApiUrl } from '@shared/constants/Urls';
import { useOrganizationStore } from '@shared/hooks/state/OrganizationContainer';
import { useTranslation } from 'react-i18next';

export default function NoAssociatedOrgBanner() {
    const { t } = useTranslation();
    const memberships = useOrganizationStore((state) => state.memberships);

    if (memberships.length > 0) return null;
    return (
        <PageBannerCard
            description={t('common:organization.noOrg.description')}
            fullHeight
            icon="orgCompany"
            title={t('common:organization.noOrg.title')}>
            <Button href={`${getBaseApiUrl()}/trial/`} startIcon="plusLight">
                {t('common:license.trial.start')}
            </Button>
            <ActivateLicenseMinorCTA />
        </PageBannerCard>
    );
}
